import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';
import divisasData from '../../../assets/divisas.json';

export function getDivisas() {
  return divisasData;
}

export const DivisasModal = ({
  divisas = [],
  isOpen,
  onClose,
  onSelect,
  selectedDivisa,
  title = 'Seleccionar Divisa',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('descripcion-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'descripcion-asc', label: 'Descripción (A-Z)' },
    { value: 'descripcion-desc', label: 'Descripción (Z-A)' },
    { value: 'codigo-asc', label: 'Código (asc)' },
    { value: 'codigo-desc', label: 'Código (desc)' },
    { value: 'iso-asc', label: 'ISO (asc)' },
    { value: 'iso-desc', label: 'ISO (desc)' },
  ];

  const filteredDivisas = (divisas.length ? divisas : divisasData).filter((divisa) =>
    divisa.descripcion.toLowerCase().includes(searchQuery.toLowerCase()) ||
    divisa.codigo.toLowerCase().includes(searchQuery.toLowerCase()) ||
    divisa.iso.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const sortedDivisas = [...filteredDivisas].sort((a, b) => {
    switch (sortBy) {
      case 'descripcion-asc':
        return a.descripcion.localeCompare(b.descripcion);
      case 'descripcion-desc':
        return b.descripcion.localeCompare(a.descripcion);
      case 'codigo-asc':
        return a.codigo.localeCompare(b.codigo);
      case 'codigo-desc':
        return b.codigo.localeCompare(a.codigo);
      case 'iso-asc':
        return a.iso.localeCompare(b.iso);
      case 'iso-desc':
        return b.iso.localeCompare(a.iso);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || 'Ordenar por';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder="Buscar divisa..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="flex-1 relative button-no-hover-effect text-sm">
            <button
              className="flex w-max items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[30vh] overflow-y-auto">
          {sortedDivisas.length > 0 ? (
            <div className="space-y-0">
              {sortedDivisas.map((divisa) => (
                <div
                  key={divisa.codigo + divisa.iso}
                  className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                    selectedDivisa && selectedDivisa.codigo === divisa.codigo ? 'bg-gray-100 font-bold' : ''
                  }`}
                  onClick={() => {
                    onSelect(divisa);
                    setSearchQuery('');
                    setIsSortOpen(false);
                    onClose();
                  }}
                >
                  <div className="flex justify-between items-start gap-2">
                    <div>
                      <p className="font-medium">{divisa.codigo} ({divisa.iso})</p>
                      <p className="text-xs text-gray-500">{divisa.descripcion}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              No se encontraron divisas para "{searchQuery}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 